import React from 'react';
import { ArrowLeft, FullLogoDark, FullLogoLight } from 'shared/assets/icons';
import { IconButton } from 'shared/components/ui/icon-button';
import { useBrowserPrefersDarkMode } from 'shared/lib/mui';

import * as Styled from './onboarding-header.style';

interface OnboardingHeaderProps {
  onBack?: () => void;
}

export const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({
  onBack,
}) => {
  const prefersDarkMode = useBrowserPrefersDarkMode();

  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.ButtonContainer>
          {!!onBack && <IconButton icon={ArrowLeft} onClick={onBack} />}
        </Styled.ButtonContainer>

        {prefersDarkMode ? (
          <FullLogoDark height="24" width="85" />
        ) : (
          <FullLogoLight height="24" width="85" />
        )}
        <Styled.Empty />
      </Styled.Content>
    </Styled.Container>
  );
};

export default OnboardingHeader;
